// extracted by mini-css-extract-plugin
export default {"TeamContainer":"Team_TeamContainer__sDwQP","Name":"Team_Name__klN6t","DefaultTeamBadgeContainer":"Team_DefaultTeamBadgeContainer__x4VUh","HomeTeam":"Team_HomeTeam__bFsWZ"};